module.exports = __webpack_public_path__ + "static/img/huawei_pay.bf9192d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/huawei_pay.png
// module id = Tdrr
// module chunks = 1